import { ColDef } from 'ag-grid-community'

/**
 * Applies hide/show visibility to a column definition based on field or colId-prefix lookup maps.
 * Returns the updated ColDef if a rule matched, or null if no rule applied.
 * Prefix rules are checked before field rules.
 */
export const applyColumnVisibility = <T>(
  col: ColDef<T>,
  fieldHideMap: Partial<Record<string, boolean>>,
  prefixHideMap: Partial<Record<string, boolean>>
): ColDef<T> | null => {
  const colId = col.colId ?? ''

  for (const [prefix, hide] of Object.entries(prefixHideMap)) {
    if (colId.startsWith(prefix)) {
      return { ...col, hide }
    }
  }

  if (col.field !== undefined && col.field in fieldHideMap) {
    return { ...col, hide: fieldHideMap[col.field] }
  }

  return null
}
